import { render, staticRenderFns } from "./UserRelevancyList.vue?vue&type=template&id=03836e1d"
import script from "./UserRelevancyList.vue?vue&type=script&lang=js"
export * from "./UserRelevancyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports